// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1___fc219a81de2d804cc39","cls2":"AuthorHeader-cls2__c6fbe675ab33beb8436c AuthorHeader-cls1___fc219a81de2d804cc39"};